const PanelContainer = {
  baseStyle: {
    p: "90px 15px 30px",
    minHeight: "calc(100vh - 123px)",
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
